import { render, staticRenderFns } from "./PhoneVerification.vue?vue&type=template&id=006356cb"
import script from "./PhoneVerification.vue?vue&type=script&lang=js"
export * from "./PhoneVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006356cb')) {
      api.createRecord('006356cb', component.options)
    } else {
      api.reload('006356cb', component.options)
    }
    module.hot.accept("./PhoneVerification.vue?vue&type=template&id=006356cb", function () {
      api.rerender('006356cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/OTPVerification/components/PhoneVerification.vue"
export default component.exports